export enum permissionConst {
  SUPER = "super",

  CREATE_ADMIN = "create-admin",
  VIEW_ADMIN = "view-admin",
  PAUSE_ADMIN = "pause-admin",
  EDIT_ADMIN = "edit-admin",
  ASSIGN_ADMIN_PERMISSION = "assign-admin-permission",

  CREATE_BRAND = "create-brand",
  EDIT_BRAND = "edit-brand",
  EDIT_BRAND_PERMISSION = "edit-brand-permission",
  MANAGE_BRAND = "manage-brand",
  SUPER_BRAND = "super-brand",

  CREATE_BRAND_USER = "create-brand-user",
  EDIT_BRAND_USER = "edit-brand-user",
}

export enum brandPermConst {
  CREATE_BRAND = "create-brand",
  EDIT_BRAND = "edit-brand",
  EDIT_BRAND_PERMISSION = "edit-brand-permission",
  MANAGE_BRAND = "manage-brand",
  SUPER_BRAND = "super-brand",
}

export const countryCodeOptions = [
  { value: "+91", label: "India (+91)" },
  { value: "+1", label: "USA (+1)" },
  { value: "+44", label: "UK (+44)" },
  { value: "+61", label: "Australia (+61)" },
  { value: "+971", label: "UAE (+971)" },
  { value: "+972", label: "Israel (+972)" },
  { value: "+973", label: "Bahrain (+973)" },
  { value: "+974", label: "Qatar (+974)" },
  { value: "+975", label: "Bhutan (+975)" },
  { value: "+976", label: "Mongolia (+976)" },
  { value: "+977", label: "Nepal (+977)" },
  { value: "+978", label: "Sri Lanka (+978)" },
  { value: "+979", label: "Maldives (+979)" },
];

//frontend->backend
export const FilterKeyValueMap = {
  // Old local keys
  audienceAge: "audienceAge",
  follower: "followerCount",
  creatorAge: "age",
  isVerified: "isVerified",
  creatorLanguage: "language",
  bioPhrases: "bioPhrases",
  location: "location",
  category: "category",
  creatorGender: "gender",
  creatorType: "accountType",
  rating: "rating",
  audienceLocations: "audienceLocation",
  audienceGender: "audienceGender",
  recentPost: "recentPost",
  hashtags: "hashtags",
  mentions: "mentions",
  avgReelViews: "avgReelViews",
  engRate: "engRate",
  avgLikes: "avgLikes",

  // New global keys
  follower_count: "followerCount",
  subscriber_count: "followerCount",
  creator_locations: "location",
  topics: "category",
  categories: "category",
  creator_gender: "gender",
  creator_age: "age",
  creator_language: "language",
  is_verified: "isVerified",
  bio_phrase: "bioPhrases",
  description_keywords: "description_keywords",
  instagram_options_reel_views: "avgReelViews",
  engagement_rate: "engRate",
  audience_locations: "audienceLocation",
  audience_age: "audienceAge",
  audience_gender: "audienceGender",
};

export const requestStatusTypeMap = {
  Pending: "warning",
  Approved: "success",
  Rejected: "danger",
};

export const requestStatusMap = {
  Pending: "Pending",
  Approved: "Approved",
  Rejected: "Rejected",
};

export const influencerSuggestStatusMap = {
  Approved: "Approved",
  "Approval-Pending": "Approval-Pending",
  Rejected: "Rejected",
};

export const getSelectOptions = (type: string) => {
  switch (type) {
    case "discovery":
      return [
        { label: "All", value: "" },
        { label: "Not Contacted", value: "offer-yet-to-be-sent" },
        { label: "First Commericals Sent", value: "offer-sent" },
        { label: "First Commericals Accepted", value: "offer-accepted" },
      ];

    case "pricing":
      return [
        { label: "All", value: "" },
        { label: "Negotiations Requested", value: "negotiations-requested" },
        { label: "Negotiations Sent", value: "negotiations-sent" },
        { label: "Negotiations Accepted", value: "negotiations-accepted" },
      ];

    default:
      return [
        { label: "Not Contacted", value: "offer-yet-to-be-sent" },
        { label: "First Commericals Sent", value: "offer-sent" },
        { label: "First Commericals Accepted", value: "offer-accepted" },
        { label: "Negotiations Requested", value: "negotiations-requested" },
        { label: "Negotiations Sent", value: "negotiations-sent" },
        { label: "Negotiations Accepted", value: "negotiations-accepted" },
        { label: "All", value: "" },
      ];
  }
};

export const getOfferOptionsMap = (type: string): Record<string, string> => {
  const options = getSelectOptions(type);
  return options.reduce<Record<string, string>>((acc, { value, label }) => {
    acc[value] = label;
    return acc;
  }, {});
};

export const draftingStatusConst = {
  Pending: "Pending",
  Success: "Success",
  Failed: "Failed",
};

export const draftingTranscriptionStatusConst = {
  Pending: "Pending",
  Success: "Success",
  Failed: "Failed",
};

export const PLATFORM_OPTIONS: { value: string; label: string }[] = [
  { value: "instagram", label: "Instagram" },
  { value: "youtube", label: "YouTube" },
  { value: "tiktok", label: "TikTok" },
  { value: "twitter", label: "Twitter" },
  { value: "twitch", label: "Twitch" },
  { value: "facebook", label: "Facebook" },
  { value: "substack", label: "Substack" },
  { value: "adSense", label: "AdSense" },
  { value: "spotify", label: "Spotify" },
  { value: "linkedIn", label: "LinkedIn" },
  { value: "beehiiv", label: "Beehiiv" },
];

export enum AdRightOptions {
  Automatic = "Automatic",
  "Brand-Decision" = "Brand-Decision",
  "Custom-Offset" = "Custom-Offset",
}
